import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const testimonials = [
  {
    id: 1,
    content: "Sales Intercept has made our website far more personal and interactive. It's helped us stand out from all the competition. It's very easy to install and intuitive to use plus the customer service is 5 star. I cannot rave about this product enough.",
    author: "Connie Newhouse",
    position: "Marketing Director",
  },
  {
    id: 2,
    content: "We saw a 43% increase in conversion rates after adding Sales Intercept to our website. The widget grabs attention immediately and keeps visitors engaged longer. The ROI has been incredible.",
    author: "Mike Cardenas",
    position: "E-commerce Manager",
  },
  {
    id: 3,
    content: "What I love about Sales Intercept is how it helps us connect with visitors on a personal level without requiring more staff. The analytics provide valuable insights into what resonates with our audience.",
    author: "Rob Stein",
    position: "CEO, Donald Ross Sportwear",
  },
];

const Testimonials = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <section id="testimonials" className="section bg-gray-50">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Trusted by <span className="text-purple-si">Growing Businesses</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our customers are saying about 
            Sales Intercept.
          </p>
        </div>

        <motion.div
          ref={ref}
          className="max-w-2xl mx-auto space-y-6"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {testimonials.map((testimonial) => (
            <motion.div
              key={testimonial.id}
              className="bg-white p-8 rounded-xl shadow-lg"
              variants={itemVariants}
            >
              <div className="mb-4">
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  ))}
                </div>
                <p className="text-gray-700 italic mb-4">"{testimonial.content}"</p>
              </div>
              <div>
                <h4 className="font-bold">{testimonial.author}</h4>
                <p className="text-sm text-gray-500">{testimonial.position}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Results metrics */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <motion.div 
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            <h3 className="text-4xl lg:text-5xl font-bold text-purple-si mb-2">43%</h3>
            <p className="text-lg font-medium">Average Conversion Increase</p>
          </motion.div>
          
          <motion.div 
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
            <h3 className="text-4xl lg:text-5xl font-bold text-orange-dark-si mb-2">2.8x</h3>
            <p className="text-lg font-medium">Longer Time on Site</p>
          </motion.div>
          
          <motion.div 
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6 }}
          >
            <h3 className="text-4xl lg:text-5xl font-bold text-aqua-si mb-2">94%</h3>
            <p className="text-lg font-medium">Customer Satisfaction</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;